import { LogManager } from 'core/logging/LogManager';
import { ReactNode, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useOutletContext } from 'react-router';

export type MobileNavRef = {
  leftContent: HTMLDivElement | null;
  rightContent: HTMLDivElement | null;
};

export const useMobileNavRef = () => {
  return {
    mobileNav: useRef<MobileNavRef>({
      leftContent: null,
      rightContent: null,
    }),
    mobileSubnav: useRef<MobileNavRef>({
      leftContent: null,
      rightContent: null,
    }),
  };
};

const logger = LogManager.getLogger('useMobileNavPortal');

export const useMobileNavPortal = () => {
  const context = useOutletContext<{ mobileNav?: MobileNavRef; mobileSubnav?: MobileNavRef } | undefined>();
  if (!context) throw new Error(`No context has been provided for the current <Outlet />`);
  const { mobileNav, mobileSubnav } = context;
  if (!mobileNav) logger.warn(`No "mobileNav" property exists in the context for the current <Outlet />`);
  if (!mobileSubnav) logger.warn(`No "mobileSubnav" property exists in the context for the current <Outlet />`);
  return {
    mobileNav: {
      renderOnLeft: useCallback(
        (content: ReactNode) => {
          if (!mobileNav?.leftContent) return null;
          return createPortal(content, mobileNav.leftContent);
        },
        [mobileNav?.leftContent]
      ),
      renderOnRight: useCallback(
        (content: ReactNode) => {
          if (!mobileNav?.rightContent) return null;
          return createPortal(content, mobileNav.rightContent);
        },
        [mobileNav?.rightContent]
      ),
    },
    mobileSubnav: {
      renderOnLeft: useCallback(
        (content: ReactNode) => {
          if (!mobileSubnav?.leftContent) return null;
          return createPortal(content, mobileSubnav.leftContent);
        },
        [mobileSubnav?.leftContent]
      ),
      renderOnRight: useCallback(
        (content: ReactNode) => {
          if (!mobileSubnav?.rightContent) return null;
          return createPortal(content, mobileSubnav.rightContent);
        },
        [mobileSubnav?.rightContent]
      ),
    },
  };
};
